var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 19.2812C9.75 19.7734 9.36328 20.125 8.90625 20.125H6.375C4.47656 20.125 3 18.6484 3 16.75V7.75C3 5.88672 4.47656 4.375 6.375 4.375H8.90625C9.36328 4.375 9.75 4.76172 9.75 5.21875C9.75 5.71094 9.36328 6.0625 8.90625 6.0625H6.375C5.42578 6.0625 4.6875 6.83594 4.6875 7.75V16.75C4.6875 17.6992 5.42578 18.4375 6.375 18.4375H8.90625C9.36328 18.4375 9.75 18.8242 9.75 19.2812ZM20.7539 11.6875L16.2891 6.90625C15.9727 6.55469 15.4453 6.55469 15.0938 6.87109C14.7422 7.1875 14.7422 7.71484 15.0586 8.06641L18.1875 11.4062H9.43359C8.97656 11.4062 8.625 11.793 8.625 12.25C8.625 12.7422 8.97656 13.0938 9.43359 13.0938H18.1523L14.9883 16.4688C14.6719 16.8203 14.6719 17.3477 15.0234 17.6641C15.2344 17.8047 15.4453 17.875 15.6211 17.875C15.832 17.875 16.043 17.8047 16.2188 17.6289L20.6836 12.8477C21.0703 12.5312 21.0703 12.0039 20.7539 11.6875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideMenu);
export default __webpack_public_path__ + "static/media/SideMenu.f25dfb8f363d1c701415b8653347b3f9.svg";
export { ForwardRef as ReactComponent };